import '@tensorflow/tfjs'; // Register tfjs kernels

import { useState, useRef, useEffect } from 'react';
import Webcam from 'react-webcam';
import backend from '@hotg-ai/rune-tflite';
import { Parameters, useForge, registerBackend } from '@hotg-ai/forge';

// Tell forge to use the tflite model handler
registerBackend(backend());

const forgeConfig: Parameters = {
  deploymentId: "c4f5b75d-6063-4d2b-8755-e9834f16240f",
  apiKey: "3f9ba92084b788c6fff42f8720ee86124c5f3034",
  baseURL: "https://prd-us-east-1-forge.hotg.ai",
  telemetry: {
      baseURL: "https://prd-us-east-1-telemetry.hotg.ai",
  },
};

const ReactTfliteInception = ({ data, setData, setLoaded }) => {
  const [image, setImage] = useState<string | undefined>();
  const forge = useForge(forgeConfig);
  const webcamRef = useRef<Webcam | null>(null);

  // We want to re-run the prediction every time our image or the forge object
  // updates.
  useEffect(() => {
    if (image && forge.state === 'loaded') {
      setLoaded(true)
      const img: HTMLImageElement = new Image();

      img.onload = () => {
        try {
          const result = forge.predict({ image: [img] });
          setData(result);
        } catch (error) {
          console.log(error);
        }
      };
      img.src = image;
    }
  }, [image, forge]);

  const videoConstraints = {
    width: 400,
    height: 300,
    facingMode: 'user',
  };

  // A callback that gets fired whenever the webcam's <video> element fires
  // its "timeupdate" event - roughly every 15-250ms. This is about as close
  // to a "onnextframe" event as we can get.
  // https://stackoverflow.com/questions/17044567/get-frame-change-in-video-html5
  const onTimeUpdated = () => {
    if (forge.state != 'loaded') {
      return;
    }
    const screenshot = webcamRef.current?.getCanvas();

    if (screenshot) {
      setImage(screenshot.toDataURL('image/jpeg'));
    }
  };

  const predictions = data
    .flatMap((v) => [...v.elements])
    .map((p, i) => <p key={i}>{p}</p>);

  return (
    <div className='webcam_container'>
       
      
      <Webcam
        audio={false}
        height={videoConstraints.height * 0.5}
        width={videoConstraints.width * 0.5}
        ref={webcamRef}
        screenshotFormat='image/jpeg'
        videoConstraints={videoConstraints}
        onTimeUpdate={onTimeUpdated}
      />
      <>{predictions}</>
    </div>
  );
};

export default ReactTfliteInception;
